/**
 * @generated SignedSource<<7c933e37965863ff48d15e10b626fbf4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BannerContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BannerAnnouncement">;
  readonly " $fragmentType": "BannerContent";
};
export type BannerContent$key = {
  readonly " $data"?: BannerContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"BannerContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "BannerContent",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BannerAnnouncement"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "f3b88ef37c897165bed4a7a7d66573d7";

export default node;
